module.exports = __webpack_public_path__ + "static/media/rakbank.8860fe30.png";